import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import style from './style.module.scss';
import Fade from '@mui/material/Fade';
import clsx from 'clsx';
import { Separator } from '../../components';
import { getLang } from '../../shared/tools';
import { ReactComponent as CloseIcon } from "./close.svg";
import CategoryBubble from './category-bubble/CategoryBubble';
import useMediaQuery from "@mui/material/useMediaQuery";
import he from "he";

const Filter = ({ cat, listFilter, isDesktop, setListFilter }) => {
  const [showMore, setShowMore] = useState(false);
  /**
   *  Children cat, first line need to be dissociated from the rest of the grid
   */
  const showMoreGridRef = useRef();
  const isSixColumns = useMediaQuery(
    `(min-width: ${style.fourColumnsScreenSize}) and (max-width: ${style.tabletBreakpoint})`
  );
  const isThreeColumns = useMediaQuery(`(max-width:  ${style.threeColumnsScreenSize})`);
  const sizeColumn = (isDesktop && 7) || (isSixColumns && 6) || (isThreeColumns && 3) || 4;
  // React i18next
  const { t } = useTranslation();

  // First row of category showed
  const firstCats = cat?.children.slice(0, sizeColumn);
  // Second + row
  const otherCats = cat?.children.slice(sizeColumn);

  // Animation on change of height not handle by CSS directly.
  useEffect(() => {
    if (showMoreGridRef?.current) {
      const height = showMoreGridRef.current.scrollHeight;
      showMoreGridRef.current.style.maxHeight = showMore ? `${height}px` : 0;
    }
  }, [showMore, showMoreGridRef?.current?.scrollHeight, isDesktop, isSixColumns]);

  /**
   * Filter of level 3 category
   */
  const applyFilter = (id) => {
    // If the filter is already applied, we remove it
    if (listFilter.includes(id)) {
      setListFilter(listFilter.filter((item) => item !== id));
    } else {
      setListFilter([...listFilter, id]);
    }
  };

  const writeCatTitle = (title) => {
    if (getLang() === 'de') {
      return title;
    }
    return title.toLowerCase();
  }

  return (
    <div className={style.filter}>
      <div className={style.filterHeader}>
        <span
          className={style.text}
        >
          {he.decode(`${t('Sort by')} ${writeCatTitle(cat?.title)}`)}
        </span>

        <div className={style.separatorContainer}>
          <Separator className={style.separator} />

          {otherCats.length > 0 && (
            <span
              className={style.showMore}
              onClick={() => setShowMore(!showMore)}
            >
              {showMore ? (
                <Fade in={true} key={1} timeout={500}>
                  <span>
                    <CloseIcon />
                    {t('Close')}
                  </span>
                </Fade>
              ) : (
                <Fade in={true} key={2} timeout={500}>
                  <span>{t('View all')}</span>
                </Fade>
              )}
            </span>
          )}
        </div>
      </div>

      <div className={style.levelThree}>
        <div className={clsx(style.catGrid, showMore && style.showAll)}>
          {firstCats.map((cat, index) => (
            <CategoryBubble
              applyFilter={applyFilter}
              key={index}
              category={cat}
              selected={listFilter.includes(cat.id)}
            />
          ))}
        </div>

        <div className={clsx(style.otherCats, showMore && style.extended)} ref={showMoreGridRef}>
          {otherCats.map((cat, index) => (
            <CategoryBubble
              applyFilter={applyFilter}
              key={index}
              isAnimated={true}
              category={cat}
              show={showMore}
              selected={listFilter.includes(cat.id)}
            />
          ))}
        </div>
      </div>

      {showMore && (
        <div className={clsx(style.filterHeader, style.footer)}>
          <Separator className={style.separator} />
          
          <span
            className={style.showMore}
            onClick={() => setShowMore(false)}
          >
            <CloseIcon />{t('Close')}
          </span>
        </div>
      )}
    </div>
  )
}
export default Filter;
